import React from 'react';
import {Grid} from 'semantic-ui-react';

export const Label = ({width, label}) => {
  return (
    <Grid.Column width={width}>
      <h4>{label}</h4>
    </Grid.Column>
  );
};

export const ColumnValue = ({width, value, className}) => {
  return (
    <Grid.Column width={width} className={className || ''}>
      {value}
    </Grid.Column>
  );
};
